import { makeStyles, Theme } from "@material-ui/core/styles";

const useStyles = makeStyles((theme: Theme) => ({
    filter: {
        alignSelf: "stretch",
        minWidth: "150px",
        "& .MuiSelect-root": {
            paddingTop: theme.spacing(1.5),
            paddingBottom: theme.spacing(1.5),
            paddingRight: theme.spacing(6),
            "& .MuiSvgIcon-root": {
                width: 20,
                height: 20,
                marginRight: theme.spacing(1),
            },
        },
    },
}));

export default useStyles;
